import { render } from "./buttonMs.vue?vue&type=template&id=f9848a6e"
const script = {}

import "./buttonMs.vue?vue&type=style&index=0&id=f9848a6e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__